import React from 'react';
import styled from 'styled-components';

const Address = styled.address`
  font-style: normal;
`;

const ContactItem = styled.div`
  span {
    display: inline-block;
    min-width: 1.25rem;
  }
`;

const ContactItems = styled.div`
`;

const Company = ({
  className,
  name: companyName,
  email,
  tel,
  telWithCountryCode,
  tel2,
  tel2WithCountryCode,
  street,
  houseNumber,
  postcode,
  city,
}) => (
  <div className={className}>
    <Address>
      {companyName && (
        <div>{companyName}</div>
      )}
      {street && (
        <div>{street} {houseNumber}</div>
      )}
      {postcode && (
        <span>{postcode}</span>
      )}
      {city && postcode && ' '}
      {city && (
        <span>{city}</span>
      )}
    </Address>
    <ContactItems>
      {tel && (
        <ContactItem>
          <span>T:</span>
          <a href={`tel:${telWithCountryCode}`}>{tel}</a>
        </ContactItem>
      )}
      {tel2 && (
        <ContactItem>
          <span>T:</span>
          <a href={`tel:${tel2WithCountryCode}`}>{tel2}</a>
        </ContactItem>
      )}
      {email && (
        <ContactItem>
          <span>E:</span>
          <a href={`mailto:${email}`}>{email}</a>
        </ContactItem>
      )}
    </ContactItems>
  </div>
);

export default styled(Company)`
  display: grid;
  grid-template-rows: auto;
  gap: 1rem;
`;
